import { GET_ALL_ROLES_SUCCESS, GET_ALL_ROLES_FAIL, LOGOUT, GET_ALL_ROLES_REQUEST } from "./types";

import customerService from "../services/customerService";
import RoleService from "../services/roleService";

export const getAllRoles = () => async (dispatch) => {
  dispatch({ type: GET_ALL_ROLES_REQUEST });
  try {
    const res = await RoleService.getAllRoles();
    console.log(res.data);
    dispatch({
      type: GET_ALL_ROLES_SUCCESS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: GET_ALL_ROLES_FAIL,
      payload: err.response.data.error,
    });
  }
};